import type { ZodErrorMap } from 'zod';

export const zodErrorMap: ZodErrorMap = (issue, ctx) => {
  let message = '';

  switch (issue.code) {
    case 'invalid_type':
      if (issue.received === 'undefined' || issue.received === 'null') {
        message = 'errors.value-required';
      } else {
        message = 'errors.value-not-valid';
      }
      break;
    case 'invalid_string':
      message = 'errors.value-not-valid';
      break;
    case 'too_small':
      message = 'errors.too-small';
      break;
    case 'too_big':
      message = 'errors.too-big';
      break;
    default:
      message = 'unknown';
      break;
  }

  return {
    message,
  };
};
